import Cookies from "js-cookie";

import {
  EDGEN_ONBOARDING_STEP_COOKIE_KEY,
  type EdgenOnboardingStep,
} from "./edgenOnboardingStep";

const COOKIE_OPTIONS: Cookies.CookieAttributes = {
  expires: 365,
  path: "/",
  sameSite: "Lax",
};

function withSecureFlag(): Cookies.CookieAttributes {
  if (typeof window === "undefined") {
    return COOKIE_OPTIONS;
  }
  return {
    ...COOKIE_OPTIONS,
    secure: window.location.protocol === "https:",
  };
}

export function setEdgenOnboardingStepCookie(step: EdgenOnboardingStep): void {
  if (typeof document === "undefined") {
    return;
  }
  Cookies.set(EDGEN_ONBOARDING_STEP_COOKIE_KEY, String(step), withSecureFlag());
}

export function clearEdgenOnboardingStepCookie(): void {
  if (typeof document === "undefined") {
    return;
  }
  Cookies.remove(EDGEN_ONBOARDING_STEP_COOKIE_KEY, { path: "/" });
}
